import {all, call, put, takeEvery, select} from "redux-saga/effects";
import {authenticate, deAuthenticate, setAuthenticationStatus, setAuthenticationSuccess, setAuthenticationFailure} from "../../reducers/authSlice";
import {getUser, setUser} from "../../reducers/userSlice";
import {authApi} from "../apis/authApi";
import axios from "axios";

// Selector to get selectedBrand from state
const getSelectedBrand = (state) => state.brand.selectedBrand;

function* authUser({payload}) {
  try {
    const response = yield call(authApi, payload);

    if (response.status < 202) {
      yield put(setAuthenticationSuccess(response));

      const selectedBrand = yield select(getSelectedBrand);
      yield put(getUser({idToken: response.data.idToken, selectedBrand}));
    } else {
      yield put(setAuthenticationFailure(response));
    }
  } catch (error) {
    yield put(setAuthenticationFailure(error));
  }
}
function* getUserFun({payload}) {
  try {
    const selectedBrand = yield select(getSelectedBrand);
    yield put(getUser({idToken: payload.data.idToken, selectedBrand}));
  } catch (error) {
    yield put(setAuthenticationFailure(error));
  }
}

function* deAuthUser() {
  localStorage.removeItem("ee-session-token");
  delete axios.defaults.headers.common["X-SESSION-TOKEN"];
}

export default function* authSaga() {
  yield all([takeEvery(authenticate.type, authUser), takeEvery(deAuthenticate.type, deAuthUser), takeEvery(setAuthenticationSuccess.type, getUserFun)]);
}
